import store from '@/store';
import { i18n } from '@/plugins/i18n';
import {
  HELP_LINKS_FF,
  BIZAI_CHAT_FF,
  AICHAT_ATTR,
  DEFAULT_QUESTION_KEY,
  HELP_WORKFLOW_NAME,
} from '../constants/helpConstants';

// See ../README.md for the three destinations, the data-aichat contract, and the helpers for
// help links passed as props into Design System components.

export function getAichatQuestion(el) {
  return (el && typeof el.getAttribute === 'function' && el.getAttribute(AICHAT_ATTR)) || null;
}

function isBizaiEligible() {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  const staffData = store.getters['StaffStore/staffData'];
  return !!hasFeature && !!hasFeature(BIZAI_CHAT_FF) && staffData?.role === 'admin';
}

export function helpDestination() {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  if (!hasFeature || !hasFeature(HELP_LINKS_FF)) return 'external';
  return isBizaiEligible() ? 'chat' : 'none';
}

export function openHelp({ message = null, source = 'help_article' } = {}) {
  store.dispatch('AiChatStore/launchWorkflow', {
    message: message || i18n.t(DEFAULT_QUESTION_KEY),
    context: { source },
    workflow: { name: HELP_WORKFLOW_NAME },
  });
}

export function helpLinkProp(value) {
  return helpDestination() === 'none' ? '' : value;
}

export function routeHelpLinkClick(event, { message, source } = {}) {
  const destination = helpDestination();
  if (destination === 'external') return destination;
  event?.preventDefault?.();
  if (destination === 'chat') openHelp({ message, source });
  return destination;
}

export function routeHelpAnchorClick(event, options) {
  if (!event?.target?.closest?.('a.VcLink')) return null;
  return routeHelpLinkClick(event, options);
}

export function installHelpGlobals(win = window) {
  /* eslint-disable no-param-reassign */
  win.helpDestination = () => helpDestination();
  win.openHelp = (opts) => openHelp(opts);
  /* eslint-enable no-param-reassign */
}

export function syncHelpLinkVisibility() {
  document.body.classList.toggle('bizai-help-hidden', helpDestination() === 'none');
}

export default {
  getAichatQuestion,
  helpDestination,
  openHelp,
  helpLinkProp,
  routeHelpLinkClick,
  routeHelpAnchorClick,
  installHelpGlobals,
  syncHelpLinkVisibility,
};
